import { render, staticRenderFns } from "./NotificationBody.vue?vue&type=template&id=802d69da&"
import script from "./NotificationBody.vue?vue&type=script&lang=ts&"
export * from "./NotificationBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports